import React from 'react';

export default function MinusIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 9.375H5L5 10.625H15V9.375Z" fill="white" />
      <path d="M15 9.375H5L5 10.625H15V9.375Z" fill="black" fillOpacity="0.5" />
    </svg>
  );
}
